"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _ResponseError = _interopRequireDefault(require("../errors/ResponseError"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
const fetchWrapper = (client, throwOnError = true, timeout = 30) => (url, param = {}) => {
  const controller = new AbortController();
  const {
    signal
  } = controller;
  const id = setTimeout(() => controller.abort(), timeout * 1000);
  const statusChecker = res => {
    clearTimeout(id);
    // Not using res.ok as that is only available to native fetch api
    if (signal.aborted) throw new Error(`Request timed out after ${timeout} seconds`);
    if (throwOnError && 'status' in res && !(res.status >= 200 && res.status < 300)) {
      throw new _ResponseError.default(res.status, res.statusText, res.url, res);
    }
    return res;
  };
  return client(url, _objectSpread(_objectSpread({}, param), {}, {
    signal
  })).then(statusChecker);
};
var _default = fetchWrapper;
exports.default = _default;